/**
 * jQuery Sketch v1.0
 * Copyright © 2018, Alexander Griffioen <mail@oscaralexander.com>
 * Published under MIT license.
 */

const pluginName = 'sketch'

class Sketch {
    constructor(el, options) {
        this.options = $.extend({}, this.defaults, options)
        this.$el = $(el)
        this.init()
    }

    init() {
        this.$canvas = this.$el.find('canvas').first()
        this.canvasX = 0
        this.canvasY = 0
        this.events = {
            'click' : Modernizr.touch ? 'touchstart' : 'click',
            'mousedown': Modernizr.touch ? 'touchstart' : 'mousedown',
            'mousemove' : Modernizr.touch ? 'touchmove' : 'mousemove',
            'mouseup' : Modernizr.touch ? 'touchend' : 'mouseup'
        },
        this.history = []
        this.isDrawing = false
        this.points = []

        if (this.$canvas.length) {
            this.canvas = this.$canvas.get(0)
            this.canvas.height = this.$canvas.height()
            this.canvas.width = this.$canvas.width()
            this.ctx = this.canvas.getContext('2d')

            // Init shadow canvas for anti-aliasing
            this.canvasMem = document.createElement('canvas')
            this.canvasMem.height = this.canvas.height
            this.canvasMem.width = this.canvas.width
            this.ctxMem = this.canvasMem.getContext('2d')

            // Init default drawing settings
            this.ctx.fillStyle = '#000000'
            this.ctx.lineCap = 'round'
            this.ctx.lineJoin = 'round'
            this.ctx.lineWidth = 4
            this.ctx.strokeStyle = '#000000'

            // Activate default brush size and color buttons
            $(`[data-sketch-brush-size='${this.ctx.lineWidth}']`, this.$el).addClass(this.options.classNameButtonActive)
            $(`[data-sketch-color='${this.ctx.strokeStyle}']`, this.$el).addClass(this.options.classNameButtonActive)

            // Init button handler
            $('[data-sketch-brush-size]', this.$el).on(this.events.click, this.onBrushSizeClick.bind(this))
            $('[data-sketch-color]', this.$el).on(this.events.click, this.onColorClick.bind(this))
            $('[data-sketch-undo]', this.$el).on(this.events.click, this.onUndo.bind(this))
            $('[data-sketch-clear]', this.$el).on(this.events.click, this.onClearClick.bind(this))
            $('[data-sketch-save]', this.$el).on(this.events.click, this.onSave.bind(this))

            // Init canvas handlers
            this.$canvas.on(this.events.mousedown, this.onMouseDown.bind(this))
            this.$canvas.on(this.events.mousemove, this.onMouseMove.bind(this))
            this.$canvas.on(this.events.mouseup, this.onMouseUp.bind(this))

            this.clear()
            this.loadImage()
            this.updateUndoState()
        } else {
            console.log('Failed to initialize Sketch plug-in. Canvas element not found.');
        }
    }

    clear() {
        [this.ctx, this.ctxMem].forEach((ctx) => {
            ctx.beginPath()
            ctx.rect(0, 0, this.canvas.width, this.canvas.height)
            ctx.fillStyle = '#FFFFFF'
            ctx.fill()
        })

        this.history = []
        this.updateUndoState()
    }

    draw() {
        let i
        let qX
        let qY

        if (this.points.length > 2) {
            this.ctx.beginPath()
            this.ctx.moveTo(this.points[0].x, this.points[0].y)

            for (i = 1; i < this.points.length - 2; i++) {
                qX = (this.points[i].x + this.points[i + 1].x) * 0.5
                qY = (this.points[i].y + this.points[i + 1].y) * 0.5
                this.ctx.quadraticCurveTo(this.points[i].x, this.points[i].y, qX, qY)
            }

            this.ctx.quadraticCurveTo(this.points[i].x, this.points[i].y, this.points[i + 1].x, this.points[i + 1].y)
            this.ctx.stroke()
        }
    }

    loadImage() {
        let img
        let src

        if (this.$el.attr('data-sketch-data')) {
            src = this.$el.attr('data-sketch-data')
            img = new Image()

            img.onload = ((e) => {
                this.ctx.drawImage(img, 0, 0)
                this.ctxMem.drawImage(img, 0, 0)
            })

            img.src = src
        }
    }

    getPoint(e) {
        if (e.type === 'touchmove') {
            e = e.originalEvent.targetTouches.item(0)
        }

        return {
            x: e.pageX - this.canvasX,
            y: e.pageY - this.canvasY
        }
    }

    onBrushSizeClick(e) {
        e.preventDefault()
        this.ctx.lineWidth = $(e.currentTarget).attr('data-sketch-brush-size')
        $('[data-sketch-brush-size]', this.$el).removeClass(this.options.classNameButtonActive)
        $(e.currentTarget).addClass(this.options.classNameButtonActive)
    }

    onClearClick(e) {
        e.preventDefault()
        this.clear()
    }

    onColorClick(e) {
        e.preventDefault()
        this.ctx.fillStyle = $(e.currentTarget).attr('data-sketch-color')
        this.ctx.strokeStyle = $(e.currentTarget).attr('data-sketch-color')
        $('[data-sketch-color]', this.$el).removeClass(this.options.classNameButtonActive)
        $(e.currentTarget).addClass(this.options.classNameButtonActive)
    }

    onMouseDown(e) {
        this.isDrawing = true
        this.setCanvasXY()
        this.snapshot()
        this.points.push(this.getPoint(e))
    }

    onMouseMove(e) {
        if (this.isDrawing) {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.ctx.drawImage(this.canvasMem, 0, 0)
            this.points.push(this.getPoint(e))
            this.draw()
        }
    }

    onMouseUp(e) {
        if (this.isDrawing) {
            if (this.points.length === 1) {
                this.ctx.beginPath()
                this.ctx.arc(this.points[0].x, this.points[0].y, this.ctx.lineWidth * 0.5, 0, Math.PI * 2, !0)
                this.ctx.closePath()
                this.ctx.fill()
            }

            this.ctxMem.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.ctxMem.drawImage(this.canvas, 0, 0)
            this.isDrawing = false
            this.points = []
        }
    }

    onSave(e) {
        e.preventDefault()
        this.$el.trigger('sketch:save', this.canvas.toDataURL('images/url'))
    }

    onUndo(e) {
        e.preventDefault()

        if (this.history.length) {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.ctx.drawImage(this.history.pop(), 0, 0)
            this.ctxMem.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.ctxMem.drawImage(this.canvas, 0, 0)
        }

        this.updateUndoState()
    }

    setCanvasXY() {
        this.canvasX = this.$canvas.offset().left
        this.canvasY = this.$canvas.offset().top
    }

    snapshot() {
        let canvasSnapshot
        let ctxSnapshot

        canvasSnapshot = document.createElement('canvas')
        canvasSnapshot.height = this.canvas.height
        canvasSnapshot.width = this.canvas.width
        ctxSnapshot = canvasSnapshot.getContext('2d')
        ctxSnapshot.drawImage(this.canvas, 0, 0)

        this.history.push(canvasSnapshot)
        this.updateUndoState()
    }

    updateUndoState() {
        this.$el.find('[data-sketch-undo]')[this.history.length ? 'removeClass' : 'addClass'](this.options.classNameButtonDisabled)
    }
}

Sketch.prototype.defaults = {
    classNameButtonActive: 'is-active',
    classNameButtonDisabled: 'is-disabled',
    classNameCanvas: 'canvas'
}

$.fn[pluginName] = function (options) {
    return this.each(function () {
        let instance = $(this).data(`plugin_${pluginName}`)

        if (!instance) {
            $(this).data(`plugin_${pluginName}`, new Sketch(this, options))
        } else {
            if (typeof options === 'string') {
                instance[options]()
            }
        }
    })
}